






































































import Vue from 'vue';

export default Vue.extend({
  name: 'Inputs',

  data() {
    return {
      query: '',
      difficulty: '',
      category: '',
      difficulties: [
        { text: 'Létt', value: '1' },
        { text: 'Meðal', value: '2' },
        { text: 'Erfitt', value: '3' },
      ],
      categories: [
        { text: 'Almenn kunnátta', value: '1' },
        { text: 'Náttúra og vísindi', value: '2' },
        { text: 'Bókmenntir og listir', value: '3' },
        { text: 'Saga', value: '4' },
        { text: 'Landafræði', value: '5' },
        { text: 'Skemmtun og afþreying', value: '6' },
        { text: 'Íþróttir og tómstundir', value: '7' },
      ],
    };
  },

  computed: {
    loading(): boolean {
      return this.$store.getters.loading;
    },
    queryCount(): boolean {
      return this.$store.getters.queryCount;
    },
    randomQuestionsCount() {
      return this.$store.getters.randomQuestions.length;
    },
  },

  methods: {
    fetchRandomQuestions(): void {
      console.log(this.query);
      const params = {
        query: this.query === null ? '' : this.query,
        category: this.category === undefined ? '' : this.category,
        difficulty: this.difficulty === undefined ? '' : this.difficulty,
      };
      this.$store.dispatch('fetchRandomQuestions', params);
    },
  },

});
